const gu = {
  "भाजपा सदस्यता अभियान - 2024": "ભાજપ સભ્યપદ અભિયાન - 2024",
  "Select Language": "ભાષા પસંદ કરો",
  Next: "પછિનુ",
  "Enter your mobile number": "તમારો મોબાઈલ નંબર દાખલ કરો",
  "I accept the Terms and Conditions, and by continuing, I consent to voluntarily become a member of the BJP":
    "હું નિયમો અને શરતો સ્વીકારું છું, અને ચાલુ રાખીને, હું સ્વેચ્છાએ ભાજપના સભ્ય બનવા માટે સહમતિ આપું છું",
  "Get OTP": "OTP મેળવો",
  "Terms and Conditions": "નિયમો અને શરતો",
  "You must tick the box to continue, as it is mandatory.":
    "તમારે ચાલુ રાખવા માટે બૉક્સ પર ટિક કરવું આવશ્યક છે, કારણ કે તે ફરજિયાત છે.",
  "Okay, Got it": "ઠીક છે, સમજાઈ ગયું",
  "Get OTP": "OTP મેળવો",
  "Enter OTP": "OTP દાખલ કરો",
  "Resend OTP": "OTP ફરીથી મોકલો",
  Continue: "ચાલુ રાખો",
  "Fill details": "વિગતો ભરો",
  "Upload Photo": "ફોટો અપલોડ કરો",
  "Profile Photo": "પ્રોફાઇલ ફોટો",
  "Mobile number": "મોબાઈલ નંબર",
  "Mrs.": "શ્રીમતી",
  "Mr.": "શ્રી",
  Ms: "કુ",
  "Full Name*": "પૂરું નામ *",
  "D.O.B": "D.O.B",
  Age: "ઉંમર",
  Gender: "લિંગ",
  Female: "સ્ત્રી",
  Male: "પુરુષ",
  Other: "અન્ય",
  "Email Id": "ઈમેલ આઈડી",
  "Add address": "સરનામું ઉમેરો",
  "House/ Flat/ Floor No.": "ઘર/ફ્લેટ/ફ્લોર નં.",
  "Current address PIN code": "વર્તમાન સરનામું પિન કોડ",
  "District*": "જિલ્લો*",
  State: "રાજ્ય",
  "Assembly constituency (AC)": "વિધાનસભા મતવિસ્તાર (AC)",
  "Tell us about your location": "અમને તમારા સ્થાન વિશે કહો",
  "It will assist us in locating other members in your area.":
    "તે અમને તમારા વિસ્તારમાં અન્ય સભ્યોને શોધવામાં મદદ કરશે.",
  "Your address as fetched": "મેળવેલ તરીકે તમારું સરનામું",
  "Referral code": "રેફરલ કોડ",
  "I certify that above provided information is correct and there is no mistake. I know that all further communication will be done on above provided details":
    "હું પ્રમાણિત કરું છું કે ઉપર આપેલી માહિતી સાચી છે અને તેમાં કોઈ ભૂલ નથી. હું જાણું છું કે આગળની બધી વાતચીત ઉપર આપેલી વિગતો પર કરવામાં આવશે",
  Save: "સાચવો",
  Select: "પસંદ કરો",
  Camera: "કેમેરા",
  or: "અથવા",
  Gallery: "ગેલેરી",
  "Support format : Jpeg, Png, Pdf": "સપોર્ટ ફોર્મેટ: Jpeg, Png, Pdf",
  Cancel: "રદ કરો",
  "Select location": "સ્થાન પસંદ કરો",
  "Provide location": "સ્થાન આપો",
  "Search results": "શોધ પરિણામો",
  "Search for a building, street name or..": "મકાન, શેરીનું નામ અથવા.. શોધો.",
  "Your address as fetched": "મેળવેલ તરીકે તમારું સરનામું",
  "Locate me": "મને શોધો",
  "Confirm location": "સ્થાનની પુષ્ટિ કરો",
  "Congratulations !": "અભિનંદન!",
  "Your primary Id is -": "તમારું પ્રાથમિક આઈડી છે -",
  "Login in to Bjp.org/membership to enhance your data, access your ID card, and refer others to join as primary members.":
    "Bjp.org/membership પર લૉગ ઇન કરો તમારો ડેટા વધારવા, તમારું ID કાર્ડ ઍક્સેસ કરવા અને અન્યને પ્રાથમિક સભ્યો તરીકે જોડાવા માટે રેફર કરો.",
  "ID CARD": "આઈડી કાર્ડ",
  "You can download your generated ID Card":
    "તમે તમારું જનરેટ કરેલ આઈડી કાર્ડ ડાઉનલોડ કરી શકો છો",
  Download: "ડાઉનલોડ કરો",
  "Go to dashboard": "ડેશબોર્ડ પર જાઓ",
  "View your profile": "તમારી પ્રોફાઇલ જુઓ",
  "Refer and add member": "સંદર્ભ લો અને સભ્ય ઉમેરો",
  Share: "શેર કરો",
  "To update your additional details and refer more member, please click here.":
    "તમારી વધારાની વિગતો અપડેટ કરવા અને વધુ સભ્યનો સંદર્ભ લેવા માટે, કૃપા કરીને અહીં ક્લિક કરો.",
  "Bharatiya Janata Party": "ભારતીય જનતા પાર્ટી",
  "6A, DEENDAYAL UPADHYAYA MARG, NEW DELHI - 110002":
    "6A, દીનદયાલ ઉપાધ્યાય માર્ગ, નવી દિલ્હી - 110002",
  Name: "નામ",
  "Membership Number": "સભ્યપદ નંબર",
  "QR Code": "QR કોડ",
  "Please select a year between 1930 and 2006.":
    "કૃપા કરીને 1930 અને 2006 વચ્ચેનું વર્ષ પસંદ કરો.",
  "Please enter a valid email address.": "કૃપા કરીને માન્ય ઇમેઇલ દાખલ કરો.",
  "Please enter 6-digit PIN code.": "કૃપા કરીને 6 અંકનો પિન કોડ દાખલ કરો.",
  "10-digit mobile number.": "10 અંકનો મોબાઈલ નંબર.",
  "Please enter a 10-digit mobile number.":
    "કૃપા કરીને 10 અંકનો મોબાઇલ નંબર દાખલ કરો.",
  "Please enter your name.": "કૃપા કરીને તમારું નામ દાખલ કરો.",
  "I pledge and willing to receive regular updates from BJP":
    "હું વચન આપું છું અને ભાજપ તરફથી નિયમિત અપડેટ્સ મેળવવા માટે તૈયાર છું",
  "Get Verification Code": "વેરિફિકેશન કોડ મેળવો",
  "Enter Verification Code": "વેરિફિકેશન કોડ દાખલ કરો",
  "Resend Verification Code": "વેરિફિકેશન કોડ ફરીથી મોકલો",
  "Provide Details": "વિગતો આપો",
  Upload: "અપલોડ કરો",
  Ok: "ઓકે",
  Calendar: "કેલેન્ડર",
  "Full Address": "સંપૂર્ણ સરનામું",
  "Privacy policy": "ગોપનીયતા નીતિ",
  Disclaimer: "અસ્વીકરણ",
  "Contact us": "અમારો સંપર્ક કરો",
  Save: "સાચવો",
  "Your primary member ID": "તમારું પ્રાથમિક સભ્ય ID",
  "Membership Card": "સભ્યપદ કાર્ડ",
  "Your Unique Referral code": "તમારો યુનિક રેફરલ કોડ",
  "Invite and add member": "આમંત્રિત કરો અને સભ્ય ઉમેરો",
  Share: "શેર કરો",
  "Click below to add more details, donate and add other members to BJP":
    "તમારા વિશે વધુ શેર કરવા, દાન આપવા અને અન્ય લોકોને ભાજપમાં જોડવા માટે નીચે ક્લિક કરો",
  "Update your details": "તમારી વિગતો અપડેટ કરો",
  "Add Referral Details": "રેફરલ વિગતો ઉમેરો",
  "Referred by (name)": "દ્વારા સંદર્ભિત (નામ)",
  "Referred by (mobile number)": "દ્વારા સંદર્ભિત (મોબાઇલ નંબર)",
  Capture: "ફોટો લો",
  "Close Camera": "કૅમેરો બંધ કરો",
  Uploading: "અપલોડ કરી રહ્યું છે",
  "Your Unique Referral Link": "તમારી યુનિક રેફરલ લિંક",
  "You've reached the maximum OTP attempts for today. Please try again tomorrow":
    "તમે આજના મહત્તમ OTP પ્રયાસો પર પહોંચી ગયા છો. કૃપા કરીને કાલે ફરી પ્રયાસ કરો",
  Miss: "કુ",
  "Full Name": "પૂરું નામ",
  "OTP limit reached for today. Please try again tomorrow":
    "આજે માટે OTP મર્યાદા સમાપ્ત થઇ ગઈ છે. કૃપા કરીને કાલે ફરી પ્રયાસ કરો",
  ": is not a Primary Member, Only Primary Members can refer":
    ": પ્રાથમિક સભ્ય નથી, ફક્ત પ્રાથમિક સભ્યો જ રીફર લઈ શકે છે",
  "Please enter valid fullname": "કૃપા કરીને માન્ય પૂર્ણ નામ દાખલ કરો",
  Upload: "અપલોડ કરો",
};

export default gu;
